// @flow

import React, { PureComponent } from 'react';
import { getBasicText } from 'web-core/src/plan-benefits';
import TooltipDetailListItem from 'client/components/plan/detail/tooltipListItem';
import 'client/styles/costList.scss';
import { getDisclaimerAsterisk } from './cost';

type Props = {
  benefits: Array<Object>,
  isPostDeductible?: boolean,
  commonTranslations: Object,
};

export default class BenefitCostList extends PureComponent<Props> {
  static defaultProps = {
    isPostDeductible: false,
    commonTranslations: {},
  };

  render() {
    const { isPostDeductible, commonTranslations } = this.props;

    return (
      <div className="benefit-cost-list">
        <div className="cost-list">
          {this.props.benefits.map((benefit) => {
            let benefitString;

            if (typeof benefit.value === 'string') {
              benefitString = benefit.value;
            } else {
              benefitString =
                `
                ${getBasicText({
                  benefit: benefit.value,
                  isPostDeductible,
                  commonTranslations,
                })}` +
                `${isPostDeductible ? '' : getDisclaimerAsterisk(benefit, this.props.benefits)}`;
            }

            return (
              <TooltipDetailListItem
                itemPath={benefit.key}
                key={benefit.key}
                keyElement={benefit.keyElement}
                value={benefitString}
                tooltip={benefit.tooltip} />
            );
          })}
        </div>
      </div>
    );
  }
}
